module.exports = __webpack_public_path__ + "static/media/transbank-logo.0575945d.webp";